<template>
  <FormContainer withoutDivider>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          label="Prénom"
          :placeholder="utilisateur?.prenom!"
          required
          disabled
          class="col-18 col-sm-36"
        />
        <WrapperInput
          label="Nom"
          :placeholder="utilisateur?.nom!"
          disabled
          class="col-18 col-sm-36"
        />
        <WrapperInput
          label="Email"
          :placeholder="utilisateur?.email!"
          disabled
          class="col-36"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { useAppStateStore } from '@/features/application'
  import { FormContainer } from '@/features/interface/demande/shared'

  const utilisateur = useAppStateStore().utilisateur
</script>
